import { takeLeading, put } from "redux-saga/effects";
import {
    IUpdateAppContext,
    updateAppContext
} from "../actions/contextActions";

import { createSuccessFetchCategories } from "../actions/categoryAction";
import { createSuccessFetchFormTypes } from "../actions/formActions";
import { createAppendToLocationList, createAppendToFacilityList, createAppendToAreaList } from "../actions/locationAction";
import { createSuccessFetchPersons } from "../actions/personAction";
import { createSuccessCategoryPermissionAction } from "../actions/permissionActions";

/**
 * Relation data is recieved in all API request with the main data, 
 * to make updating those context values easier this sata centralizes those updating action.
 * To update some or all context data, you just throw object containing lists of data.
 */

const makeUpdateContextData = () =>
    function* saga(action: IUpdateAppContext) {
        const context = action.payload.context;

        if (context.categories) {
            yield put(createSuccessFetchCategories(context.categories));
        }

        if (context.formTypes) {
            yield put(createSuccessFetchFormTypes(context.formTypes));
        }

        if (context.locations) {
            yield put(createAppendToLocationList(context.locations));
        }
        if (context.facilities) {
            yield put(createAppendToFacilityList(context.facilities));
        }
        if (context.areas) {
            yield put(createAppendToAreaList(context.areas));
        }

        if (context.persons) {
            yield put(createSuccessFetchPersons(context.persons));
        }

        if (context.categoryPermissions) {
            yield put(createSuccessCategoryPermissionAction(context.categoryPermissions));
        }
    };

export default function create() {
    return takeLeading(
        updateAppContext,
        makeUpdateContextData(),

    );
}
